import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { ACCOUNT_ACTIVE, AccountObject, AccountType } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'

@Component({
  selector: 'tc-non-buyers-warning',
  templateUrl: './non-buyers-warning.component.html',
  styleUrls: ['./non-buyers-warning.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButtonModule,
  ],
})
export class NonBuyersWarningComponent implements OnChanges {
  @Input() selectedCompanies: DeepReadonly<AccountObject>[] = []
  @Output() buyersChange = new EventEmitter<DeepReadonly<AccountObject>[]>()

  buyers: DeepReadonly<AccountObject>[] = []
  nonBuyers: DeepReadonly<AccountObject>[] = []
  inactiveBuyers: DeepReadonly<AccountObject>[] = []
  archivedBuyers: DeepReadonly<AccountObject>[] = []

  get hasNonBuyers(): boolean {
    return this.nonBuyers.length > 0
  }

  get hasInactiveBuyers(): boolean {
    return this.inactiveBuyers.length > 0
  }

  get hasArchivedBuyers(): boolean {
    return this.archivedBuyers.length > 0
  }

  get hasErrors(): boolean {
    return this.hasNonBuyers || this.hasInactiveBuyers || this.hasArchivedBuyers
  }

  ngOnChanges() {
    this.nonBuyers = this.selectedCompanies.filter(c => c.type !== AccountType.BUYER)
    const allBuyers = this.selectedCompanies.filter(c => c.type === AccountType.BUYER)
    this.archivedBuyers = allBuyers.filter(c => c.archived)
    const nonArchivedBuyers = allBuyers.filter(c => !c.archived)
    this.inactiveBuyers = nonArchivedBuyers.filter(c => c.status !== ACCOUNT_ACTIVE)
    this.buyers = nonArchivedBuyers.filter(c => c.status === ACCOUNT_ACTIVE)
    this.buyersChange.emit(this.buyers)
  }

  removeNonBuyers() {
    this.nonBuyers = []
    this.selectedCompanies = [...this.buyers, ...this.inactiveBuyers, ...this.archivedBuyers]
    this.buyersChange.emit(this.buyers)
  }

  removeInactiveBuyers() {
    this.inactiveBuyers = []
    this.selectedCompanies = [...this.buyers, ...this.nonBuyers, ...this.archivedBuyers]
    this.buyersChange.emit(this.buyers)
  }

  removeArchivedBuyers() {
    this.archivedBuyers = []
    this.selectedCompanies = [...this.buyers, ...this.nonBuyers, ...this.inactiveBuyers]
    this.buyersChange.emit(this.buyers)
  }
}